import axios from 'axios';
import { baseurl, baseurl_utily_api } from './Constants/Contants';

//Validation
export const COPYVIEWDAILYCHECKENDPOINT = async (queryParams) => {
  return axios.get(`${baseurl}/view_copy_of_daily_check`, {
    params: queryParams,
  });
};

export const VIEWDAILYCHECKENDPOINT = async (queryParams) => {
  return axios.get(`${baseurl}/view_daily_check`, {
    params: queryParams,
  });
};

export const VIEWFETCHRAWMETADATAENDPOINT = async (queryParams) => {
  return axios.get(`${baseurl}/view_fetch_raw_meta_data`, {
    params: queryParams,
  });
};

export const VIEWMOMANDYOYENDPOINT = async (queryParams) => {
  return axios.get(`${baseurl}/view_mom_and_yoy`, {
    params: queryParams,
  });
};

export const VIEWPRODTOCERTIFYENDPOINT = async (queryParams) => {
  return axios.get(`${baseurl}/view_prod_to_certify`, {
    params: queryParams,
  });
};

export const fetchData = async (endpoint, queryParams = {}) => {
  try {
    const { data } = await axios.get(`${baseurl}/${endpoint}`, {
      params: queryParams,
    });
    return data;
  } catch (error) {
    console.error('Error fetching data', error);
    throw error;
  }
};

export const postDataApi = async (endpoint, data, token) => {
  try {
    const response = await axios.post(
      `${baseurl_utily_api}/Transactions/${endpoint}/`,
      data,
      {
        headers: { Authorization: token },
      },
    );
    return response;
  } catch (error) {
    console.error('Error posting data', error);
    throw error;
  }
};

export const postData2 = async (endpoint, data = null) => {
  try {
    const response = await axios.post(`${baseurl}/${endpoint}`, data);
    return response;
  } catch (error) {
    console.error('Error posting data', error);
    throw error;
  }
};

export const postData = async (endpoint, data = null) => {
  try {
    const response = await axios.post(`${baseurl}/${endpoint}`, data);
    return response.data;
  } catch (error) {
    console.error('Error posting data', error);
    throw error;
  }
};
